// The heading panel at the top of the workflow landing page. Uses the app's shared glass container
// `criteria-card criteria-card--glass` — the same one the old Process Preference header used — so the
// hero and the three workflow cards are one material.
export default function WorkflowHero() {
  return (
    <div className="criteria-card criteria-card--glass wl-hero">
      <h1 className="wl-hero-title">What&rsquo;s your workflow today?</h1>
      <p className="wl-hero-lede">
        Power your next deal with AI-driven workflows. Generate investor-ready documents, screen
        comparable companies, and curate buyer or target lists in minutes.{' '}
        <strong>Choose an option to get started.</strong>
      </p>
    </div>
  );
}
